import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Guard } from '../../components/layout/Guard';

const ReconciliationPage = lazy(() => import('./ReconciliationPage'));

const routes: RouteObject[] = [
  { path: '/reconciliation', element: <Guard any={['recon.read']}><ReconciliationPage /></Guard> },
];
export default routes;
